import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useStudentTheme } from '@context/StudentThemeContext';

/**
 * Bridges the shared `StudentThemeContext` (which persists the choice and puts
 * `.student-dark` on the shell) to a Journey-styled icon button. Using the same
 * context means CLASSIC ⇄ JOURNEY keep one remembered theme.
 */
export const ThemeToggle: React.FC<{ className?: string }> = ({ className }) => {
  const { theme, toggleTheme } = useStudentTheme();
  const { t } = useTranslation('journey');
  const dark = theme === 'dark';
  const label = dark ? t('shell.themeToLight', 'Switch to light theme') : t('shell.themeToDark', 'Switch to dark theme');
  return (
    <button
      type="button"
      className={className ? `sp-iconbtn ${className}` : 'sp-iconbtn'}
      onClick={toggleTheme}
      aria-label={label}
      title={label}
    >
      {dark ? <Sun size={18} /> : <Moon size={18} />}
    </button>
  );
};
